import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Textarea } from "@/components/elements/Textarea";
import { TUserSettingForm } from "@/features/user-setting/types/UserSettingForm";
import { black, divider, text } from "@/theme/colors";
import { Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TAccountInfoFormProps = {};

export const AccountInfoForm: FC<TAccountInfoFormProps> = () => {
  const methods = useFormContext<TUserSettingForm>();
  const { control, getValues } = methods;

  const userEmail = getValues("userEmail");
  const userNewEmail = getValues("userNewEmail");
  return (
    <InnerBox padding={3} showDivider={false} borderColor={divider.high}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          アカウント情報
        </Typography>
      </Stack>

      <Grid mt={2} container gap="4px" columnSpacing="20px">
        <Grid item xs={4}>
          <FormField control={control} name="userFullName">
            <Input sx={{ mt: 0.5 }} />
          </FormField>
        </Grid>
        <Grid item xs={8} />
        <Grid item xs={4}>
          <Typography variant="cap12" color={text.primary}>
            メールアドレス
          </Typography>
          <Stack mt={1}>
            <Textarea disabled value={`${userEmail}${userNewEmail ? `\n${userNewEmail} (確認中)` : ""}`} minRows={2} color={black[90]} />
          </Stack>
        </Grid>
        <Grid item xs={8} />
        <Grid item xs={4}>
          <FormField control={control} name="userDepartment">
            <Input sx={{ mt: 0.5 }} />
          </FormField>
        </Grid>
        <Grid item xs={4}>
          <FormField control={control} name="userPosition">
            <Input sx={{ mt: 0.5 }} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
